<div class="right-panel h-100  text-grey">
  <div class="d-flex flex-column h-100">
    <div class="actionBar">
      <div class="flex-grow-1 h-100">
        <input 
          class="search w-100"
          type="text" 
          placeholder="Search repositories..." 
          [(ngModel)]="searchTerm"
          (input)="filterRepositories()">
      </div>
      <button (click)="loadRepositories()"
              type="button" 
              class="actionBtn"
              triggers="hover"
              ngbTooltip="Refresh Repositories">
        <span class="bi bi-arrow-clockwise"></span>
      </button>
      <button (click)="createRepository()" 
              type="button" 
              class="actionBtn"
              triggers="hover"
              ngbTooltip="Create New Repository">
        <span class="bi bi-plus-circle-fill"></span>
      </button>
    </div>

    <div class="right-side w-100">
      <div class="w-100">
        <div class="jobs">
          <table class="table table-hover table-condensed"
                        cellspacing="0"
                        id="sessionInfoList"
                        style="border-collapse: collapse; white-space: nowrap">
            <thead>
              <tr class="table-list-head jobHeadRow" style="color: white; background-color: var(--s-primary-color);">
                <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default">#</a>
                </th>
                <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default">Name</a>
                </th>
                <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default">Registry</a>
                </th>
                <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default">Tags</a>
                </th>
                <!-- <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default">Last Updated</a>
                </th> -->
                <!-- <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default">Actions</a>
                </th> -->
              </tr>
            </thead>
            <tbody>
              <tr class="table-list-row jobRow" style="cursor: pointer;"
                *ngFor="let repo of filteredRepositories; let i = index">
                <td style="cursor: pointer" scope="row">{{ i + 1 }}</td>
                <td style="cursor: pointer" scope="row">
                  <div class="repo-info">
                    <strong class="repo-name">{{ repo.name }}</strong>
                    <div class="repo-details">
                      <span class="full-name">{{ repo.registry }}/{{ repo.name }}</span>
                    </div>
                  </div>
                </td>
                <td style="cursor: pointer" scope="row">
                  <span>{{ repo.registry_name }}</span>
                </td>
                <td style="cursor: pointer" scope="row">
                  <div class="tags-info">
                    <span class="tag-count">{{ repo.tag_count }} tags</span>
                    <div class="tag-list" *ngIf="repo.tags && repo.tags.length > 0">
                      <span 
                        *ngFor="let tag of repo.tags.slice(0, 3)" 
                        class="tag-badge">
                        {{ tag }}
                      </span>
                      <span *ngIf="repo.tags.length > 3" class="more-tags">
                        +{{ repo.tags.length - 3 }} more
                      </span>
                    </div>
                  </div>
                </td>
                <!-- <td style="cursor: pointer" scope="row">
                  <div class="update-info">
                    <span class="update-date">{{ formatDate(repo.last_updated) }}</span>
                    <span class="relative-time">{{ getRelativeTime(repo.last_updated) }}</span>
                  </div>
                </td> -->
                <!-- <td style="cursor: pointer" scope="row">
                  <div class="actions">
                    <button (click)="deleteRepository(repo.id)" class="btn btn-sm btn-outline-danger">Delete</button>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <ngx-spinner
        bdColor="rgba(0,0,0,0)"
        size="default"
        zIndex="1"
        color="var(--s-primary-color)"
        type="ball-spin"
        [fullScreen]="false"
        >
        <p class="pleaseWait text-grey">Please wait ...</p>
    </ngx-spinner>
</div>